module.exports = __webpack_public_path__ + "img/Laughlin.309dbc26.webp";